
const isObject = (value) => {
    return (value && typeof value === 'object' && !Array.isArray(value));
}

const getJsonDiffPaths = (oldObj, newObj, currentPath = '') => {
    let paths = [];

    const keys = new Set([...(oldObj ? Object.keys(oldObj) : []), ...(newObj ? Object.keys(newObj) : [])]);

    for (const key of keys) {
        let pathKey;

        if (currentPath === '' && key === 'meta') {
            continue;
        }

        //if !isNaN(key) //todo
        if (!isNaN(key) && (Array.isArray(oldObj) || Array.isArray(newObj))) {
            pathKey = '[' + key + ']';
        } else if (currentPath) {
            pathKey = '.' + key;
        } else {
            pathKey = key;
        }

        const newPath = currentPath + pathKey;

        const oldValue = oldObj ? oldObj[key] : undefined;
        const newValue = newObj ? newObj[key] : undefined;

        if (isObject(oldValue) && isObject(newValue)) {
            paths = paths.concat(getJsonDiffPaths(oldValue, newValue, newPath));
        } else if (Array.isArray(oldValue) && Array.isArray(newValue)) {
            paths = paths.concat(getJsonDiffPaths(oldValue, newValue, newPath));
        } else if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
            paths.push(newPath);
        }
    }

    return paths;
}

const getKeyValueFromJson = (json, pathKey) => {
    let pathKeySplit = pathKey.split("[");
    if (pathKeySplit.length === 1) {
        let value = json[pathKey];
        return value;
    }
    let sliceNumber = pathKeySplit[1].replace("]", "");
    return json[pathKeySplit[0]]?.[sliceNumber];
}

const getValueFromPath = (json, pathString) => {

    let keySeparatedPath = pathString.split(".");
    for (let pathKey of keySeparatedPath) {
        if (json && typeof json === 'object')
            json = getKeyValueFromJson(json, pathKey);
    }
    return json;
};

const updateTrackedChanges = (allChanges = {}, oldResourceJson, newResourceJson, userName) => {
    const diffPaths = getJsonDiffPaths(oldResourceJson, newResourceJson);
    if (diffPaths.length === 0) { //Means no changes were made
        return;
    }

    const preTrackedVersion = parseInt(oldResourceJson?.meta?.versionId || 1); //It's making sure that preTrackedVersion is at least 1
    for (const path of diffPaths) {
        if (allChanges[path]) {
            allChanges[path].savedversion = preTrackedVersion + 1;
            allChanges[path]["savedvalue"] = getValueFromPath(newResourceJson, path);
            if (allChanges[path]["versionlog"]) {
                if (allChanges[path]["versionlog"][allChanges[path]["versionlog"].length - 1][0] !== preTrackedVersion + 1) {
                    allChanges[path]["versionlog"].push([preTrackedVersion + 1, userName]);
                }
            } else {
                allChanges[path]["versionlog"] = [[preTrackedVersion + 1, userName]];
            }
            if (allChanges[path].status !== "active") {
                //Is this the correct way of handling it? NO - it will need to recognize changes on top of changes
                allChanges[path].pretrackedversion = preTrackedVersion;
                allChanges[path]["pretrackedvalue"] = getValueFromPath(oldResourceJson, path);
                allChanges[path].status = "active";
            }
        } else {
            allChanges[path] = {
                pretrackedversion: preTrackedVersion,
                pretrackedvalue: getValueFromPath(oldResourceJson, path),
                savedversion: preTrackedVersion + 1,
                savedvalue: getValueFromPath(newResourceJson, path),
                versionlog: [[preTrackedVersion + 1, userName]],
                comments: [],
                status: "active"
            };
        }
    }
}

const addPathAndValue = (resourceJson, pathString, newValue) => {
    if (!resourceJson || !pathString) return;
    const keys = pathString.match(/[^.[\]]+/g);
    if (!keys) { return; }
    let current = resourceJson;
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (current[key] === undefined || current[key] === null) {
            const nextKey = keys[i + 1];
            current[key] = /^\d+$/.test(nextKey) ? [] : {}; //If the key is a number, then the element is an array, otherwise a dictionary
        }
        current = current[key];
    }
    const lastKey = keys[keys.length - 1];
    if (typeof newValue === "object") {
        current[lastKey] = JSON.parse(JSON.stringify(newValue));
    } else {
    current[lastKey] = newValue;
    }
};

const traversePath = (resourceJson, pathString) => {
    if (!pathString) return { parent: undefined, lastKey: undefined };
    const keys = pathString.match(/[^.[\]]+/g);
    if (!keys) return { parent: undefined, lastKey: undefined };
    let current = resourceJson;
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (current[key] === undefined || current[key] === null) {
            return { parent: undefined, lastKey: undefined };
        }
        current = current[key];
    }
    return { parent: current, lastKey: keys[keys.length - 1] };
}

const deleteValueAtPath = (resourceJson, pathString) => {
    const { parent, lastKey } = traversePath(resourceJson, pathString);
    if (parent) {
        delete parent[lastKey];
    }
};

const changeValueAtPath = (resourceJson, pathString, newValue) => {
    const { parent, lastKey } = traversePath(resourceJson, pathString);
    if (parent) {
        parent[lastKey] = newValue;
    }
};
/*
const getValueAtPath = (resourceJson, pathString) => {
    const { parent, lastKey } = traversePath(resourceJson, pathString);
    return parent[lastKey];
};
*/
const processTrackedChanges = (allChanges = {}, allAcceptedResourceJson, allRejectedResourceJson) => {
    for (const path in allChanges) {
        let status = allChanges[path].status;
        let pretrackedvalue = allChanges[path].pretrackedvalue;
        if (status === "active") {
            let allRejectedValue = getValueFromPath(allRejectedResourceJson, path);
            if (allRejectedValue === undefined && pretrackedvalue !== "[No value.]") {
                addPathAndValue(allRejectedResourceJson, path, pretrackedvalue);
            } else if (allRejectedValue !== undefined && pretrackedvalue === "[No value.]") {
                deleteValueAtPath(allRejectedResourceJson, path);
            } else if (JSON.stringify(pretrackedvalue) !== JSON.stringify(allRejectedValue)) {
                changeValueAtPath(allRejectedResourceJson, path, pretrackedvalue);
            }
        }
        if (status === "reject") {
            let allRejectedValue = getValueFromPath(allRejectedResourceJson, path);
            let allAcceptedValue = getValueFromPath(allAcceptedResourceJson, path);
            if (allRejectedValue === undefined && pretrackedvalue === "[No value.]") {
                if (allAcceptedValue !== undefined) {
                    deleteValueAtPath(allAcceptedResourceJson, path);
                }
            } else if (allRejectedValue === undefined) {
                addPathAndValue(allRejectedResourceJson, path, pretrackedvalue);
                addPathAndValue(allAcceptedResourceJson, path, pretrackedvalue);
            } else if (pretrackedvalue === "[No value.]") {
                deleteValueAtPath(allRejectedResourceJson, path);
                if (allAcceptedValue !== undefined) {
                    deleteValueAtPath(allAcceptedResourceJson, path);
                }
            } else if (JSON.stringify(pretrackedvalue) !== JSON.stringify(allAcceptedValue)) {
                changeValueAtPath(allRejectedResourceJson, path, pretrackedvalue);
                changeValueAtPath(allAcceptedResourceJson, path, pretrackedvalue);
            }
        }
    }
};

const checkForAdditions = (a, b, diff, diffParent) => {  //checks for additions (or changes to content)
    let changed = false;
    for (let key in a) {
        let willIgnore = willIgnoreKey(key);
        addDiffKey(diff, diffParent, key, a, b, false);
        if (b === undefined || b[key] === undefined) {
            //This element was added in the newer version
            diff[key] = { "CHANGETYPE": "added", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": jsonCopy(a[key]) };
            changed = true;
        } else if (checkIfDictionary(a[key]) && checkIfDictionary(b[key])) {
            if (JSON.stringify(a[key], stringifyReplacer) !== JSON.stringify(b[key], stringifyReplacer)) {
                if (diff[key]["VALUE"] === undefined) {
                    diff[key]["VALUE"] = { "CHANGETYPE": "innerchange", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": {}, "PREVIOUSVALUE": b[key] }; //or innerchange
                }
                checkForChanges(a[key], b[key], diff[key]["VALUE"], diff[key]);
                changed = true;
            }
        } else if (Array.isArray(a[key]) && Array.isArray(b[key])) {
            //TO DO
            //OR JUST LET IT PASS because the checkForDeletions function takes care of it? Or move that code here?
        } else if (a[key] === b[key]) {
            //no change
            //addDiffKey(diff, diffParent, key, a, b, willIgnore);
            diff[key] = { "CHANGETYPE": "nochange", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": jsonCopy(a[key]), "PREVIOUSVALUE": jsonCopy(b[key]) };
        } else {
            //change
            //addDiffKey(diff, diffParent, key, a, b, willIgnore);
            diff[key] = { "CHANGETYPE": "changed", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": jsonCopy(a[key]), "PREVIOUSVALUE": jsonCopy(b[key]) };
            //diff[key]["CHANGETYPE"] = "changed";
            if (!willIgnore) {
                changed = true;
            }
        }

    }
    return changed;
}

//copied from server jsdonDiffFunctions.js

const willIgnoreKey = (key) => {
    if (key === "versionId" || key === "lastModified" || key === "lastUpdated" || key === "date") {
        return true;
    } else {
        return false;
    }
}

const addDiffKey = (diff, diffParent, key, a, b, willIgnore) => {
    if (diff === undefined) {
        if (diffParent[key] === undefined) {
            //Probably won't occur
            //console.log("WEIRD");
            diffParent[key] = { "CHANGETYPE": "nochange", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": {}, "PREVIOUSVALUE": jsonCopy(b[key]) };
        } else {
            diffParent[key]["VALUE"] = { "CHANGETYPE": "nochange", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": {}, "PREVIOUSVALUE": jsonCopy(b[key]) };
        }

    } else if (diff[key] === undefined) {
        diff[key] = { "CHANGETYPE": "nochange", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": {}, "PREVIOUSVALUE": jsonCopy(b[key]) };
    }
}

const jsonCopy = (value) => {
    try {
        return JSON.parse(JSON.stringify(value));
    } catch {
        return;
    }
}

const checkIfDictionary = (element) => {
    return (typeof element === "object" && !Array.isArray(element) && element); //Boolean, true or false
}

const stringifyReplacer = (k, value) => {
    if ((value instanceof Object && !(value instanceof Array))) {
        return Object.keys(value)
            .sort()
            .reduce((sorted, key) => {
                sorted[key] = value[key];
                return sorted
            }, {})
    } else {
        return value;
    }
}

const checkForDeletions = (a, b, diff, diffParent) => {
    let changed = false;
    for (let key in b) {
        let willIgnore = willIgnoreKey(key);
        addDiffKey(diff, diffParent, key, a, b, false); //If the other function worked correctly and ran before this one, this shouldn't do anything
        if (a[key] === undefined) {
            //This element was removed in the newer version
            diff[key] = { "CHANGETYPE": "deleted", "WILLIGNORE": willIgnore, "VALUE": {}, "PREVIOUSVALUE": jsonCopy(b[key]) };
            changed = true;
        } else if (checkIfDictionary(a[key]) && checkIfDictionary(b[key])) {
            if (JSON.stringify(a[key], stringifyReplacer) !== JSON.stringify(b[key], stringifyReplacer)) {
                if (diff[key]["VALUE"] === undefined) {
                    diff[key]["VALUE"] = { "CHANGETYPE": "innerchange", "WILLIGNORE": willIgnore, "ELEMENTNAME": key, "VALUE": {}, "PREVIOUSVALUE": b[key] }; //or innerchange
                }
                checkForChanges(a[key], b[key], diff[key]["VALUE"], diff);
                changed = true;
            }
        } else if (Array.isArray(a[key]) && Array.isArray(b[key])) {
            //this can go in the other function maybe???
            let sameArray = false;
            if (a[key].length > b[key].length) {
                diff[key]["CHANGETYPE"] = "longerarray";
                changed = true;
            } else if (a[key].length < b[key].length) {
                diff[key]["CHANGETYPE"] = "shorterarray";
                changed = true;
            } else {
                if (JSON.stringify(a[key]) === JSON.stringify(b[key])) {
                    sameArray = true;
                } else {
                    let arrayA = a[key].map(entry => { return JSON.stringify(entry, stringifyReplacer) });
                    let arrayB = b[key].map(entry => { return JSON.stringify(entry, stringifyReplacer) });
                    if (JSON.stringify(arrayA) === JSON.stringify(arrayB)) {
                        sameArray = true;
                    } else {
                        diff[key]["CHANGETYPE"] = "arraychange";   //This may later be changed to arrayorderchange
                        changed = true;
                    }
                }
                //
            }
            if (!sameArray) {
                let stringifiedEntriesA = a[key].map(entry => { return JSON.stringify(entry) });
                let stringifiedEntriesAMatchTrack = jsonCopy(stringifiedEntriesA);
                let stringifiedEntriesB = b[key].map(entry => { return JSON.stringify(entry) });
                let longerArray = stringifiedEntriesA.length > stringifiedEntriesB.length ? stringifiedEntriesA : stringifiedEntriesB; //Gets the longerArray
                let deleteCount = 0;
                for (let index in longerArray) {
                    let aEntry = stringifiedEntriesA[index];
                    let bEntry = stringifiedEntriesB[index];
                    if (aEntry && bEntry) {
                        if (aEntry === bEntry) {
                            //THERE'S A MATCH AT THAT INDEX
                            diff[key]["VALUE"][index] = { "CHANGETYPE": "nochange", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": JSON.parse(aEntry) };
                            delete stringifiedEntriesAMatchTrack[index]; //So it won't be checked later
                            deleteCount += 1;
                        } else {
                            diff[key]["VALUE"][index] = { "CHANGETYPE": "changed", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": JSON.parse(aEntry), "PREVIOUSVALUE": JSON.parse(bEntry) };
                            //It may have been re-ordered or it's changed, will check on the next loop through
                        }
                    } else if (bEntry) {
                        diff[key]["VALUE"][index] = { "CHANGETYPE": "deleted", "WILLIGNORE": false, "ELEMENTNAME": key, "PREVIOUSVALUE": JSON.parse(bEntry) };
                    } else if (aEntry) {
                        diff[key]["VALUE"][index] = { "CHANGETYPE": "added", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": JSON.parse(aEntry) };
                    } else {
                        break;
                    }
                }

                for (let index in longerArray) {
                    let aEntry = stringifiedEntriesA[index];
                    let bEntry = stringifiedEntriesB[index];
                    if (aEntry !== bEntry) {
                        if (bEntry) {
                            //checks to see if it exists in the new array
                            let value;
                            if (a[key][index]) {
                                value = jsonCopy(a[key][index]);
                            }
                            if (deleteCount === longerArray.length) { //means that all the entries are already accounted for
                                diff[key]["VALUE"][index] = { "CHANGETYPE": "deleted", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": value, "PREVIOUSVALUE": jsonCopy(b[key][index]) };
                                //no further checking needed for this entry
                            } else {
                                let foundIndex = stringifiedEntriesAMatchTrack.indexOf(bEntry);
                                if (foundIndex === -1) {
                                    //It will be changedordeleted, and it will go inside and look at what changed
                                    diff[key]["VALUE"][index] = { "CHANGETYPE": "changedordeleted", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": {}, "PREVIOUSVALUE": jsonCopy(b[key][index]) };
                                    if (aEntry) {
                                        if (checkIfDictionary(a[key][index]) && checkIfDictionary(b[key][index])) {
                                            //addDiffKey(diff[key]["VALUE"], diffParent, index, a[key], b[key], false);
                                            if (key === "concept") {
                                                //print(diff[key]["VALUE"]);
                                                //dsaadsads()
                                            }
                                            changed = checkForChanges(a[key][index], b[key][index], diff[key]["VALUE"][index]["VALUE"], diff[key]) || changed;
                                        }
                                    }
                                } else {
                                    //FOUND A MATCH
                                    diff[key]["VALUE"][foundIndex] = { "CHANGETYPE": "reordered", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": jsonCopy(a[key][foundIndex]) };
                                    //diff[key]["VALUE"][index]["CHANGETYPE"] 
                                    if (diff[key]["VALUE"][index]?.["CHANGETYPE"] === "changed") {
                                        diff[key]["VALUE"][index]["CHANGETYPE"] = "previousvaluemoved";
                                    } else if (diff[key]["VALUE"][index]?.["CHANGETYPE"] === "deleted") {
                                        diff[key]["VALUE"][index]["CHANGETYPE"] = "deletedpreviousvaluemoved";
                                    }
                                    if (b[key][foundIndex] !== undefined && JSON.stringify(b[key][foundIndex])) {
                                        diff[key]["VALUE"][foundIndex]["PREVIOUSVALUE"] = jsonCopy(b[key][foundIndex]);
                                    }
                                    let tempFoundIndex = stringifiedEntriesAMatchTrack.indexOf(JSON.stringify(diff[key]["VALUE"]?.[foundIndex]?.["PREVIOUSVALUE"]));
                                    if (tempFoundIndex !== -1) {
                                        diff[key]["VALUE"][foundIndex]["CHANGETYPE"] = "reorderedandpreviousvaluemoved";
                                    }
                                    delete stringifiedEntriesAMatchTrack[foundIndex]; //So it won't be checked/matched later, it's accounted for
                                    deleteCount += 1;
                                }
                            }
                        } else if (aEntry) {
                            if (deleteCount === b[key].length) {
                                if (diff[key]["VALUE"][index]?.["CHANGETYPE"] === "reordered") {
                                    diff[key]["VALUE"][index] = { "CHANGETYPE": "reorderedadded", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": jsonCopy(a[key][index]) };
                                } else {
                                    diff[key]["VALUE"][index] = { "CHANGETYPE": "added", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": jsonCopy(a[key][index]) };
                                }
                                //no further checking needed for this entry
                            } else {
                                //diff[key]["VALUE"][index] = { "CHANGETYPE": "changedoradded", "WILLIGNORE": false, "ELEMENTNAME": key, "VALUE": jsonCopy(a[key][index]) };
                                //a little too difficult to compare to an old version's entry since we don't know which index to compare to, so we'll skip
                            }
                        }
                    }
                }
                if (deleteCount === longerArray.length) {
                    diff[key]["CHANGETYPE"] = "arrayorderchange";       //Meaning it's the same exact content, but the ordered is just different
                } else if (diff[key]["CHANGETYPE"] === "longerarray") {
                    diff[key]["CHANGETYPE"] = "arraychange";
                }
            }
        } else {
            //IGNORE, because this was already taken care of in the other loop
        }
    }
    //let parent know a change is inside
    return changed;
}

const checkForChanges = (a, b, diff, diffParent) => {
    let changed = false;
    changed = checkForAdditions(a, b, diff, diffParent) || changed;
    changed = checkForDeletions(a, b, diff, diffParent) || changed;
    if (changed) {
        if (diffParent?.CHANGETYPE) {
            //print(JSON.stringify(diffParent, null, 2).substr(0, 400));
        }
        if (diffParent && (diffParent["CHANGETYPE"] === "nochange" || diffParent["CHANGETYPE"] === "changedordeleted" || diffParent["CHANGETYPE"] === "changedoradded")) {    //maybe I can add other CHANGETYPEs too
            diffParent["CHANGETYPE"] = "innerchange";
        }
    }
    return changed;
}

const jsonDiff = (newJson, oldJson) => {
    let diff = {};
    checkForChanges(newJson, oldJson, diff, undefined);
    return diff;
}

export { updateTrackedChanges, processTrackedChanges, jsonDiff };